import type { ClientStage, WarmthLevel } from '@/types/client';

export const STAGE_LABELS: Record<ClientStage, string> = {
  lead: 'Lead',
  prospect: 'Prospect',
  active: 'Active',
  dormant: 'Dormant',
  inactive: 'Inactive',
};

/** Tailwind class pairs: [bg, text] */
export const STAGE_COLORS: Record<ClientStage, { bg: string; text: string; dot: string }> = {
  lead: {
    bg: 'bg-led-cyan/10',
    text: 'text-led-cyan',
    dot: 'bg-led-cyan shadow-[0_0_6px_var(--led-cyan)]',
  },
  prospect: {
    bg: 'bg-led-blue/10',
    text: 'text-led-blue',
    dot: 'bg-led-blue shadow-[0_0_6px_var(--led-blue)]',
  },
  active: {
    bg: 'bg-led-green/10',
    text: 'text-led-green',
    dot: 'bg-led-green shadow-[0_0_6px_var(--led-green)]',
  },
  dormant: {
    bg: 'bg-led-amber/10',
    text: 'text-led-amber',
    dot: 'bg-led-amber shadow-[0_0_6px_var(--led-amber)]',
  },
  inactive: {
    bg: 'bg-surface-3/50',
    text: 'text-muted-foreground',
    dot: 'bg-muted-foreground',
  },
};

export const WARMTH_COLORS: Record<WarmthLevel, { bg: string; text: string; dot: string }> = {
  warm: {
    bg: 'bg-led-green/10',
    text: 'text-led-green',
    dot: 'bg-led-green shadow-[0_0_6px_var(--led-green)]',
  },
  cooling: {
    bg: 'bg-led-amber/10',
    text: 'text-led-amber',
    dot: 'bg-led-amber shadow-[0_0_6px_var(--led-amber)]',
  },
  cold: {
    bg: 'bg-led-red/10',
    text: 'text-led-red',
    dot: 'bg-led-red shadow-[0_0_6px_var(--led-red)]',
  },
};

export const WARMTH_LABELS: Record<WarmthLevel, string> = {
  warm: 'Warm',
  cooling: 'Cooling',
  cold: 'Cold',
};

export const ALL_STAGES: ClientStage[] = ['lead', 'prospect', 'active', 'dormant', 'inactive'];

/** Returns a Tailwind bg class for a 1-5 rating value. */
export function ratingColorClass(value: number): string {
  if (value >= 4) return 'bg-led-green';
  if (value >= 3) return 'bg-led-amber';
  return 'bg-led-red';
}
